'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ignoreError = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoreError = exports.ignoreError = (0, _getIn2.default)(['meta', 'error', 'ignore']);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/ignoreError.js
// module id = 852
// module chunks = 2 3